import React from 'react'
import CardWImage from '../../../blocks/cards/CardWImage'
import Styling from '../../../styling'
import NextImage from '../../../blocks/images/NextImage'
import MomentFormatter from '../../../formatters/MomentFormatter'

import { EditorialContentAPI } from '../../../../data/publications'
import { translateIt } from '../../../../data/translations'
import Link from 'next/link'
import { Route } from '../../../../routers/routes'


export default function ECWImage(props) {
  const { 
    item, 
    className='',
    countryId, 
    imageColSpan=4,
    headingSize,
    bodyPaddingX,
    bodyPaddingY,

    showPreHeading=true,
    showPreHeadingImage=true,
    showBody=true,
    showTag=true,
    showDate=true,
    showImage=true,
    isCard,
  } = props
  return (
    <>
      <Link className={`${className}`} href={Route.insightDetail(item)}>
        <CardWImage
          countryId={countryId || item.country_id}
          item={item}
          image={showImage && item.image_main_url}
          imageAlt={showImage && item.image_main_alt}
          preHeading={showPreHeading && item.instrument_name}
          preHeadingImage={showPreHeadingImage && item.instrument_logotype}
          preHeadingImageAlt={`Logotype for ${item.instrument_name}`}
          heading={item.title}
          headingSize={headingSize}
          tag={showTag && (
            <span className={EditorialContentAPI.getKindClassName(item.kind)}>
              {translateIt(countryId, EditorialContentAPI.getKindSlug(item.kind))}
            </span>
          )}
          date={showDate && item.published_at}
          body={showBody && item.preamble}
          imageColSpan={imageColSpan}
          bodyPaddingX={bodyPaddingX}
          bodyPaddingY={bodyPaddingY}
          isCard={isCard}
        />
      </Link>

    </>
  )
}
